(function () {
  // container-type: inline-size en .product-block choca con su rol de item flex de ancho
  // en % (usado en todas las grillas/carruseles de product-block): la containment de
  // tamaño anula el automatic minimum size del item, y las tarjetas colapsan de forma
  // intermitente (peor cuantas menos filas/columnas hay). Confirmado aislando la causa en
  // devtools — quitar container-type de todo el subárbol es lo único que lo arregla.
  // Por eso el ajuste responsive de las tarjetas se hace con ResizeObserver + clases,
  // no con @container.
  if (typeof ResizeObserver === 'undefined') return;

  var BREAKPOINTS = [290, 250, 220, 190];
  var CLASS_PREFIX = 'pb-max-';

  function applyClasses(el, width) {
    BREAKPOINTS.forEach(function (bp) {
      el.classList.toggle(CLASS_PREFIX + bp, width <= bp);
    });
  }

  var resizeObserver = new ResizeObserver(function (entries) {
    entries.forEach(function (entry) {
      applyClasses(entry.target, entry.contentRect.width);
    });
  });

  function collectProductBlocks(node) {
    if (node.nodeType !== 1) return [];
    var blocks = node.matches('.product-block') ? [node] : [];
    if (node.querySelectorAll) {
      blocks = blocks.concat(Array.prototype.slice.call(node.querySelectorAll('.product-block')));
    }
    return blocks;
  }

  function observeAll(root) {
    collectProductBlocks(root).forEach(function (el) {
      resizeObserver.observe(el);
    });
  }

  function unobserveAll(root) {
    collectProductBlocks(root).forEach(function (el) {
      resizeObserver.unobserve(el);
    });
  }

  // Cubre carga inicial, resultados ajax (búsqueda/colección), clones de Owl Carousel,
  // quick view, drawers — cualquier lugar donde aparezcan/desaparezcan .product-block
  // dinámicamente, sin depender de enganchar cada punto del tema que los agrega.
  var mutationObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(observeAll);
      mutation.removedNodes.forEach(unobserveAll);
    });
  });

  function init() {
    observeAll(document.body);
    mutationObserver.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
